import theme from "@/styles/theme/theme";

export const desktopCssScreen = theme.breakpoints.up("xl"); // 1536
export const desktopMediumCssScreen = theme.breakpoints.down("lg"); // 1200
export const cssScreen1024 = theme.breakpoints.down("br1024"); // 1024
export const tabletCssScreen = theme.breakpoints.down("md"); // 900
export const tabletSmallScreen = theme.breakpoints.down("br768"); // 768
export const mobileBigCssScreen = theme.breakpoints.down("sm"); // 600
export const cssScreen480 = theme.breakpoints.down("br480"); // 480
export const mobileMediumCssScreen = theme.breakpoints.down("mobM") // 420
export const mobileSmallCssScreen = theme.breakpoints.down("mobS") // 330
export const smallDesktopScreenBetween = theme.breakpoints.between("lg","xl") // 1200 - 1536